import { addSpinner, removeSpinner } from '../utilities/spinner.js';
import elements from '../utilities/elements.js';
import moment from 'moment';

function PostListBlock( blockEl ){
  this.blockEl = blockEl;
  this.accessDenied = (blockEl.getAttribute('data-access-denied') == 'true') ? true : false ;
  this.redirectUrl = (blockEl.getAttribute('data-redirect-url')) ? blockEl.getAttribute('data-redirect-url') : false ;
  this.postType = (blockEl.getAttribute('data-post-type') == 'post') ? 'posts' : blockEl.getAttribute('data-post-type') ;
  this.taxonomy = ( blockEl.getAttribute('data-taxonomy') == 'category' ) ? 'categories' : blockEl.getAttribute('data-taxonomy') ;
  this.term = blockEl.getAttribute('data-term');
  this.numResults = blockEl.getAttribute('data-num-results');
  this.postListEl = blockEl.getElementsByClassName('post-list')[0];
  this.searchForm = this.blockEl.getElementsByTagName('FORM')[0];
  this.searchInput = this.searchForm.getElementsByTagName('INPUT')[0];
  this.searchForm.addEventListener( 'submit', e => this.searchFormSubmit(e) );

  this.load();
}

PostListBlock.prototype.load = function ( searchValue ) {

  this.clearPostList();

  addSpinner( this.postListEl );

  let searchParams = ( searchValue ) ? `&search=${ searchValue }` : '' ;

  let url = `/wp-json/wp/v2/${ this.postType }/?${ this.taxonomy }=${ this.term }&orderby=date&order=desc&per_page=${ this.numResults }${ searchParams }`;

  fetch( url )
    .then( response => {
      return response.json()
    })
    .then( posts => {
      if(posts.length){
        removeSpinner( this.postListEl );
        posts.forEach( post => {
          let postEls = this.createPostEl( post );
          elements.appendChildren( this.postListEl, [postEls.title, postEls.date]);
        });
      } else {
        removeSpinner( this.postListEl );
        let noResultsEl = document.createElement('p');
        noResultsEl.classList.add('no-results');
        let noResultsText = document.createTextNode('No results for this category.');
        noResultsEl.appendChild(noResultsText);
        this.postListEl.appendChild(noResultsEl);
      }
    })
};

PostListBlock.prototype.createPostEl = function ( post ) {
  let postTitle = document.createElement('a');
  //chekc if access allowed
  if( ! this.accessDenied ){
    //if publication, use file link, else use post link
    if( this.postType == 'publications'){
      if( post.acf ){
        if( post.acf.publication_attachment ){
          postTitle.href = post.acf.publication_attachment.url;
          postTitle.target = "_blank";
        } else {
          postTitle.href = post.link;
        }
      } else {
        postTitle.href = post.link;
      }
    } else {
      postTitle.href = post.link;
    }
  } else {
    //if access denied and redirect url set
    if( this.redirectUrl.length > 0 ){
      postTitle.href = `/${this.redirectUrl}`;
    }
  }
  postTitle.innerHTML = post.title.rendered; //not the safest, but a quick way to decode the html entities returned by wp api
  //bulletin post type - prefix with number
  if( this.postType == 'bulletin' ){
    if( post.acf.bulletin_number ){
      postTitle.innerHTML = post.acf.bulletin_number + ' - ' + postTitle.innerHTML;
    }
  }
  let postDate = document.createElement('p');
  postDate.classList.add('date');
  let dateDisplay = moment(post.date).format('D/M/Y');
  let postDateText = document.createTextNode( dateDisplay );
  postDate.appendChild( postDateText );

  return {
    title: postTitle,
    date: postDate
  };

};


PostListBlock.prototype.searchFormSubmit = function (e) {
  e.preventDefault();
  this.load( this.searchInput.value )
};

PostListBlock.prototype.clearPostList = function () {
  [...this.postListEl.children].forEach( child => {
    this.postListEl.removeChild( child );
  })
};

export default PostListBlock;
